import React from "react"
import { Redirect } from "react-router-dom"
import * as sHelper from "../helpers/session_helper"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Slider from "../pages/Administrator/HomePage/slider"
// import WhyChooseUs from "../pages/Administrator/HomePage/whyChooseUs"
import AboutOrganization from "../pages/Administrator/AboutOrganization"


// whyChooseUs
import WhyChooseUsIndex from "../pages/Administrator/WhyChooseUs/index"
import WhyChooseUsCreate from "../pages/Administrator/WhyChooseUs/create"

// Course
import CourseTypeIndex from "../pages/Administrator/CourseType/index"
import CourseTypeCreate from "../pages/Administrator/CourseType/create"
import CourseIndex from "../pages/Course/index"
import CourseCreate from "../pages/Course/create"

import ServiceIndex from "../pages/Service/index"
import ServiceCreate from "../pages/Service/create"

import PaymentHistoryIndex from "../pages/PaymentHistory/index"
import ServiceHistoryIndex from "../pages/ServiceHistory/index"

// Question Bank
import QuestionBankIndex from "../pages/QuestionBank/index"
import QuestionBankCreate from "../pages/QuestionBank/create"
import QuestionBankBulkCreate from "../pages/QuestionBank/bulkEntry"

import Course from "../pages/CourseCurriculam/courseDetailModel"

import CourseModuleIndex from "../pages/CourseModule/index"
import CourseModuleCreate from "../pages/CourseModule/create"

// Zoom
import ZoomIndex from "../pages/Zoom/index"
import ZoomIndex2 from "../pages/Zoom/redirect"
import WebView from "../pages/Zoom/webView"
import ZoomMeetingRoom from "../pages/Zoom/meetingRoom"

// Event
import EventTypeIndex from "../pages/Administrator/EventType/index"
import EventTypeCreate from "../pages/Administrator/EventType/create"
import EventIndex from "../pages/Administrator/Event/index"
import EventCreate from "../pages/Administrator/Event/create"

// AcademicProfile
import AcademicProfileIndex from "../pages/AcademicProfile/index"
import AcademicProfileCreate from "../pages/AcademicProfile/create"
import ParticipantCheck from "../pages/AcademicProfile/Participant"

// BookNow
import BookNow from "../pages/BookNow/create"

// InstructorProfile
import InstructorProfileIndex from "../pages/InstructorProfile/index"
import InstructorProfileCreate from "../pages/InstructorProfile/create"

// FooterPage
import ContactUSPage from "../pages/Administrator/FooterPages/contactUS"
import FAQPage from "../pages/Administrator/FooterPages/faq"
import PrivacyPolicyPage from "../pages/Administrator/FooterPages/privacyPolicy"
import TermAndConditionPage from "../pages/Administrator/FooterPages/termsAndCondition"

// News & Blog
import NewsIndex from "../pages/Administrator/News/index"
import NewsCreate from "../pages/Administrator/News/create"
import BlogIndex from "../pages/Administrator/Blog/index"
import BlogCreate from "../pages/Administrator/Blog/create"

// Page
import PageIndex from "../pages/Administrator/Page/index"
import PageCreate from "../pages/Administrator/Page/create"

// Web Message
import WebMessageIndex from "../pages/Administrator/WebMessage/index"
import WebMessageCreate from "../pages/Administrator/WebMessage/create"

// Notification
import NotificationIndex from "../pages/Administrator/Notification/index"
import NotificationCreate from "../pages/Administrator/Notification/create"

// ErrorPage
import Page000 from "../pages/ErrorPage/page-000"
import Page200 from "../pages/ErrorPage/page-200"
import Page404 from "../pages/ErrorPage/page-404"
import Page500 from "../pages/ErrorPage/page-500"

// Account
import ChartOfAccountIndex from "../pages/ChartOfAccount/index"
import ChartOfAccountCreate from "../pages/ChartOfAccount/create"
import TransactionIndex from "../pages/Transaction/index"
import TransactionCreate from "../pages/Transaction/create"

// Cheque
import BankAccountIndex from "../pages/BankAccount/index"
import BankAccountCreate from "../pages/BankAccount/create"
import ChequeIndex from "../pages/Cheque/index"
import ChequeCreate from "../pages/Cheque/create"

// Report
import BalanceSheet from "../pages/Report/balanceStatement"
import IncomeStatement from "../pages/Report/incomeStatement"
import CustomReport from "../pages/Report/filterReport"
import ChequeReport from "../pages/Report/chequeReport"

// User
import UserIndex from "../pages/User/index"
import UserCreate from "../pages/User/create"

// Profile
import UserProfile from "../pages/Authentication/UserProfile/index"


import HeaderImage from "../pages/HeaderImage/create"


// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"


const userRoutes = [
  { path: "/dashboard", component: Dashboard ,roles: []},
  { path: "/home-page-slider", component: Slider ,roles: ['admin']},
  // { path: "/home-page-why-choose-us", component: WhyChooseUs },
  { path: "/about-organization", component: AboutOrganization ,roles: ['admin']},

  //Page
  { path: "/why-choose-us-create", component: WhyChooseUsCreate ,roles: ['admin']},
  { path: "/why-choose-us-list", component: WhyChooseUsIndex ,roles: ['admin']},
  
  //Page
  { path: "/page-create", component: PageCreate ,roles: ['admin']},
  { path: "/page-list", component: PageIndex ,roles: ['admin']},

  //Page
  { path: "/web-message-create", component: WebMessageCreate ,roles: ['admin']},
  { path: "/web-message-list", component: WebMessageIndex ,roles: ['admin']},

  //Page
  { path: "/notification-create", component: NotificationCreate ,roles: ['admin']},
  { path: "/notification-list", component: NotificationIndex ,roles: ['admin']},

  //Course
  { path: "/course-type-create", component: CourseTypeCreate ,roles: ['admin']},
  { path: "/course-type-list", component: CourseTypeIndex ,roles: ['admin']},
  { path: "/course-create", component: CourseCreate ,roles: ['admin']},
  { path: "/course-list", component: CourseIndex ,roles: ['admin']},

  { path: "/payment-history", component: PaymentHistoryIndex ,roles: ['admin','payment','course']},
  { path: "/service-history", component: ServiceHistoryIndex ,roles: ['admin','service','course']},

  { path: "/course", component: Course ,roles: ['admin','participant','instructor']},
  
  { path: "/header-image", component: HeaderImage, roles: ['admin']},

  { path: "/course-module-list", component: CourseModuleIndex ,roles: ['admin']},
  { path: "/course-module-create", component: CourseModuleCreate ,roles: ['admin']},

  { path: "/service-list", component: ServiceIndex ,roles: ['admin']},
  { path: "/service-create", component: ServiceCreate ,roles: ['admin']},

  //Zoom
  { path: "/join-meeting-1", component: ZoomIndex ,roles: ['admin']},
  { path: "/join-meeting-2", component: ZoomIndex2 ,roles: ['admin']},
  // { path: "/join-meeting-3", component: WebView },
  { path: "/meeting-room", component: ZoomMeetingRoom ,roles: ['admin']},

  //AcademicProfile
  { path: "/academic-profile-create", component: AcademicProfileCreate ,roles: ['admin']},
  { path: "/academic-profile-list", component: AcademicProfileIndex ,roles: ['admin','course']},

  //Question Bank
  { path: "/question-bank-create-bulk", component: QuestionBankBulkCreate ,roles: ['admin']},
  { path: "/question-bank-create", component: QuestionBankCreate ,roles: ['admin']},
  { path: "/question-bank-list", component: QuestionBankIndex ,roles: ['admin']},

  //BookNow
  { path: "/book-now", component: BookNow ,roles: ['admin']},

  //InstructorProfile
  { path: "/instructor-profile-create", component: InstructorProfileCreate ,roles: ['admin']},
  { path: "/instructor-profile-list", component: InstructorProfileIndex ,roles: ['admin']},

  //FooterPage
  { path: "/contact-us", component: ContactUSPage, roles: ['admin']},
  { path: "/faq", component: FAQPage, roles: ['admin']},
  { path: "/privacy-policy", component: PrivacyPolicyPage ,roles: ['admin']},
  { path: "/terms-and-condition", component: TermAndConditionPage ,roles: ['admin']},

  //Event
  { path: "/event-type-create", component: EventTypeCreate ,roles: ['admin']},
  { path: "/event-type-list", component: EventTypeIndex ,roles: ['admin']},
  { path: "/event-create", component: EventCreate ,roles: ['admin']},
  { path: "/event-list", component: EventIndex ,roles: ['admin']},

  //NewsBlog
  { path: "/news-create", component: NewsCreate ,roles: ['admin']},
  { path: "/news-list", component: NewsIndex ,roles: ['admin']},
  { path: "/blog-create", component: BlogCreate ,roles: ['admin']},
  { path: "/blog-list", component: BlogIndex ,roles: ['admin']},
  
  //Account
  { path: "/chart-of-account", component: ChartOfAccountCreate ,roles: ['admin']},
  { path: "/chart-of-account-list", component: ChartOfAccountIndex ,roles: ['admin']},
  { path: "/transaction", component: TransactionCreate ,roles: ['admin']},
  { path: "/transaction-list", component: TransactionIndex ,roles: ['admin']},

  //Cheque
  { path: "/bank-account", component: BankAccountCreate ,roles: ['admin']},
  { path: "/bank-account-list", component: BankAccountIndex ,roles: ['admin']},
  { path: "/cheque", component: ChequeCreate ,roles: ['admin']},
  { path: "/cheque-list", component: ChequeIndex ,roles: ['admin']},

  //Report
  { path: "/balance-sheet", component: BalanceSheet ,roles: ['admin']},
  { path: "/income-statement", component: IncomeStatement ,roles: ['admin']},
  { path: "/custom-report", component: CustomReport ,roles: ['admin']},
  { path: "/cheque-report", component: ChequeReport ,roles: ['admin']},

    
  //User
  { path: "/user-create", component: UserCreate ,roles: ['admin']},
  { path: "/user-list", component: UserIndex ,roles: ['admin']},

  // //profile
  { path: "/profile", component: UserProfile ,roles: []},
  { path: "/user-profile", component: UserProfile ,roles: []},

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [

  { path: "/logout", component: Logout ,roles: []},
  { path: "/login", component: Login ,roles: []},
  { path: "/forgot-password", component: ForgetPwd ,roles: []},
  { path: "/register", component: Register ,roles: []},
  { path: "/join-meeting", component: WebView ,roles: []},
  
  // AcademicProfile
  { path: "/new-enroll", component: () => <Redirect to="/participant-registration?status=new" /> ,roles: []},
  { path: "/participant-registration", component: AcademicProfileCreate ,roles: []},
  { path: "/participant", component: ParticipantCheck ,roles: []},

  { path: "/book-now", component: BookNow ,roles: []},
  { path: "/book-now-new", component: BookNow ,roles: []},
  
  { path: "/payment-checking", component: Page000 ,roles: []},
  { path: "/page-200", component: Page200 ,roles: []},
  { path: "/page-404", component: Page404 ,roles: []},
  { path: "/page-500", component: Page500 ,roles: []}
]

export { userRoutes, authRoutes }